import React from "react";
import type { ReactNode } from "react";
import { s } from "../styles";
import { money } from "../helpers";

interface MoneyFieldProps {
  num?: string;
  label: ReactNode;
  value: number | string | null | undefined;
  shaded?: boolean;
  centerVal?: boolean;
}

export default function MoneyField({
  num,
  label,
  value,
  shaded,
  centerVal,
}: MoneyFieldProps) {
  const { d, c } = money(value);
  return (
    <div style={s.fb}>
      <div style={s.lbl}>{label}</div>
      <div style={s.field}>
        {num ? <span style={s.bn}>{num}</span> : null}
        {centerVal ? (
          <span style={{ ...s.val, ...s.valCtr }}>{d}</span>
        ) : (
          <>
            <span style={s.val}>{d}</span>
            <span style={shaded ? { ...s.cents, ...s.centsSh } : s.cents}>
              {c}
            </span>
          </>
        )}
      </div>
    </div>
  );
}